import Component from '@glimmer/component';
// @ts-ignore setComponentTemplate not defined in TS, but it exists
import { setComponentTemplate } from '@ember/component';
import { hbs } from 'ember-cli-htmlbars';
import { action } from '@ember/object';
import { isEventTargetInWormhole } from 'cio/utils/wormhole';
import { schedule } from '@ember/runloop';
import isDestroyed from 'cio/utils/is-destroyed';

// Overrides the LinkTo component, which does two things:
// - the regular LinkTo component breaks in the demo, because it doesn't
//   recognize the routes we point to (they're in a different routing tree)
// - we don't want to be able to route anywhere anyway, so we replace all
//   links with empty links
class DemoLinkTo extends Component {
  isInWormhole = false;
  closestTooltiplikeParent: HTMLElement | null = null;

  @action
  onClick(e: MouseEvent) {
    e.preventDefault();
  }

  @action
  didInsert(element: HTMLElement) {
    schedule('afterRender', () => {
      if (isDestroyed(this)) {
        return;
      }

      // Many of the links in the VWB render within other popups. Our
      // tooltips/popups aren't smart enough to know when they render within
      // another popup, which means hovering over the nested tooltip's content
      // will cause the parent popup to close.
      // This is a hack to work around that. When we hover over the link
      // tooltip's content, we artificially keep the parent popup open.
      this.isInWormhole = isEventTargetInWormhole({ target: element });

      if (this.isInWormhole) {
        // find closest popup or tooltip content parent
        this.closestTooltiplikeParent = element.closest(
          '.fly-tooltip[role="button"], .fly-popover[role="button"]',
        ) as HTMLElement | null;
      }
    });
  }

  @action
  keepParentPopupOpen() {
    if (!this.isInWormhole || this.closestTooltiplikeParent == null) {
      return;
    }

    this.closestTooltiplikeParent.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true, cancelable: true }));
  }

  @action
  closeParentPopup() {
    if (!this.isInWormhole || this.closestTooltiplikeParent == null) {
      return;
    }

    this.closestTooltiplikeParent.dispatchEvent(new MouseEvent('mouseleave', { bubbles: true, cancelable: true }));
  }
}
export default setComponentTemplate(
  // @ts-ignore - mismatch between two libraries defining `TemplateFactory`
  hbs`{{! template-lint-disable link-href-attributes no-a-tags-that-are-not-real-links }}
<FlyTooltip @direction='bottom' @contextual={{true}} {{did-insert this.didInsert}} as |tooltip|>
  <tooltip.trigger>
    <a ...attributes class='{{if @disabled "disabled"}}' href='' {{on 'click' this.onClick}}>{{yield}}</a>
  </tooltip.trigger>

  <tooltip.content>
    <div {{on 'mouseenter' this.keepParentPopupOpen}} {{on 'mouseleave' this.closeParentPopup}}>
      <a href='https://fly.customer.io/signup' target='_blank' rel='noopener noreferrer'>Start a free trial</a>
      to explore this feature.
    </div>
  </tooltip.content>
</FlyTooltip>`,
  DemoLinkTo,
);
